import { Box, Divider, Flex, Icon, Select, SelectField, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight } from "react-icons/fi";

const perPage = [ 5, 10, 15, 20, 25, 30];

type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
}
type IndicadorData = {
	id: string;
	nome: string;
	cid: string
	doc: string;
	phone: string;
	comissao: number;
}
interface DataTablePaginateParams {
	cli_length: number;
	pesq_length: number;
	pesqClientes: IndicadorData[];
	controls: ControlsData;
	setControls: (control: ControlsData) => void;
	handleUpdateList: (page: number, perPage: number, clients: IndicadorData[]) => void;
}

const DataTablePaginate: React.FC<DataTablePaginateParams> = ({ 
	cli_length,
	pesq_length,
	pesqClientes,
	handleUpdateList,
}) => {
	const [controls, setControls] = useState({
		page: 1,
		perPage: 5,
		totalPage: Math.ceil(cli_length / 5),
	});

	function next() {
		let auxPage = controls.page + 1;

		if (auxPage > controls.totalPage) {
			auxPage -= 1;
		}
		setControls({ ...controls, page: auxPage });

		handleUpdateList(auxPage, controls.perPage, pesqClientes);
	};

	function prev() {
		let auxPage = controls.page - 1;

		if (auxPage < 1) {
			auxPage += 1;
		}
		setControls({ ...controls, page: auxPage });

		handleUpdateList(auxPage, controls.perPage, pesqClientes);
	};

	function goTo(page: number) {
		if (page < 1) {
			page = 1;
		}

		setControls({ ...controls, page });

		if (controls.page > controls.totalPage) {
			setControls({ ...controls, page: controls.totalPage });
		}

		handleUpdateList(page, controls.perPage, pesqClientes);
	};

	async function handleControlsPerPage(event: string) {
		const perPage = Number(event);

		setControls({
			page: 1,
			perPage,
			totalPage: Math.ceil(pesq_length / perPage),
		});

		handleUpdateList(1, perPage, pesqClientes);
	};

	return (
		<Flex w="100%" p="2" flexDir="column">
			<Divider orientation='horizontal' size="sm" />

			<Flex
				flexDir={["column", "row"]}
				justify="center"
				align="center"
				w="100%"
				p="2"
			>
				{/* POR PÁGINA */}
				<Flex
					as="form"
					justify="end"
					align="center"
				>
					<Text
						fontSize="13"
						fontWeight="500"
						color="gray.400"
						mr="1"
					>
						items por pag.
					</Text>
					<Box>
						<Select 
							name="per_page"
							size="xs"
							fontWeight="500"
							isDisabled
							onChange={e => handleControlsPerPage(e.target.value)}
						>
							{perPage.map(pPage => {
								return (
									<option key={pPage} value={pPage}>{pPage}</option>
								)
							})}
						</Select>
					</Box>
				</Flex>
				
				{/* INDICES */}
				<Flex align="center" px="2">
					<Text fontSize="13" fontWeight="500" color="gray.400">
						{controls.page * controls.perPage > pesq_length
							? pesq_length
							: `${controls.page * controls.perPage - controls.perPage + 1}
								- ${controls.page * controls.perPage} de ${pesq_length}`
						}
					</Text>
				</Flex>

				{/* SETAS */}
				<Flex align="center" px="2">
					<Text as="button" onClick={() => goTo(1)}>
						<Icon as={FiChevronsLeft} fontSize="26" color="gray.400" />
					</Text>

					<Text as="button" onClick={prev}>
						<Icon as={FiChevronLeft} fontSize="24" color="gray.400" />
					</Text>

					<Text as="button" onClick={next}>
						<Icon as={FiChevronRight} fontSize="24" color="gray.400" />
					</Text>

					<Text as="button" onClick={() => goTo(controls.totalPage)}>
						<Icon as={FiChevronsRight} fontSize="26" color="gray.400" />
					</Text>
				</Flex>
			</Flex>
		</Flex>
	)
}

export default DataTablePaginate;